<template>
    <v-row align="end" style="height: calc(100vh - 150px);">
    <v-col >
    <v-form
      autocomplete="new"
      aria-autocomplete="false"
      ref="form"
      v-model="valid"
      :lazy-validation="true"
    >
      <v-row dense>
        <v-col>
          <v-text-field
            dense
            dark
            color="pink"
            label="E-mail"
            name="login"
            type="email"
            class="my-0"
            required
            v-model="username"
          ></v-text-field>
          <v-text-field
            dense
            dark
            required
            color="pink"
            id="password"
            label="Contraseña"
            name="password"
            type="password"
            class="my-0"
            v-model="password"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-form>
    <v-row dense>
      <v-col>
        <v-btn color="pink" dark block x-large @click="doLogin" :loading="status.loggingIn">Acceder</v-btn>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <v-btn
          dark
          block
          large
          text
          style="text-transform:none;font-weight:400"
        >¿No puedes acceder a tu cuenta?</v-btn>
      </v-col>
    </v-row>
  </v-col>
    </v-row>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      isLoading: false,
      valid: true,
      username: "",
      password: ""
    };
  },
  computed: {
    ...mapState("account", ["status"]),
    hasError: function() {
      return this.submitted && this.status.error;
    }
  },
  methods: {
    ...mapActions("account", ["login", "logout"]),
    doLogin() {
      if (this.$refs.form.validate()) {
        const { username, password } = this;
        this.login({ username, password, route: '/home' });
      
      }
    }
  },
  created() {
    // reset login status
    this.logout();
  }
};
</script>

<style>
</style>